<form [formGroup]="skjemakontroll()">
  <mat-stepper [linear]="true" #steg>
    <mat-step [stepControl]="skjemakontroll().controls.skjema" label="{{'Tittel og skjema'|translate}}">
      <div class="steg-skjema">
        <h2>{{ 'Hva slags undersøkelse vil du lage?'|translate }}</h2>
        <fieldset>
          <mat-form-field>
            <mat-label>{{ "Tittel på spørreundersøkelse" | translate }}</mat-label>
            <input matInput [formControl]="skjemakontroll().controls.skjema.controls.tittel" data-testid="tittel-felt">
            <mat-hint align="start">{{'Visningsnavn i Styreplan og i PDF-rapport'|translate}}</mat-hint>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ "Velg spørreskjema" | translate }}</mat-label>
            <mat-select [formControl]="skjemakontroll().controls.skjema.controls.skjema" [compareWith]="erValgtSkjema" panelClass="spørreskjema-felt-opsjoner-panel" data-testid="skjema-felt">
              <mat-select-trigger>
                @if (skjemakontroll().value.skjema!.skjema != null) {
                  <div class="tittel">{{ skjemakontroll().value.skjema!.skjema!.tittel }}</div>
                  <div class="beskrivelse">
                    <html-formatert [innhold]="skjemakontroll().value.skjema!.skjema!.beskrivelse"/>
                  </div>
                }
              </mat-select-trigger>
              @for (skjema of tilgjengeligeSkjema(); track skjema.id) {
                <mat-option [value]="skjema">
                  <div class="tittel">{{ skjema.tittel }}</div>
                  <div class="beskrivelse">
                    <html-formatert [innhold]="skjema.beskrivelse"/>
                  </div>
                </mat-option>
              }
            </mat-select>
            @if (skjemakontroll().value.skjema!.skjema == null) {
              <mat-hint align="start">{{ 'Velg et spørreskjema for å se en forhåndsvisning av alle spørsmål'|translate }}</mat-hint>
            }
          </mat-form-field>

          @if (valgtSkjemaSomUndersoekelse() != null) {
            <div class="skjema-forhåndsvisning">
              <div class="tittel">{{ 'Forhåndsvisning av "{skjema}" ({antall} spørsmål)'|translate:{skjema: skjemakontroll().value.skjema!.skjema!.tittel, antall: valgtSkjemaAntallSpoersmaal()} }}</div>
              <spoerreundersoekelse-besvarelse-skjema [skjemakontroll]="valgtSkjemaSomUndersoekelse()!"/>
              <!--<spoerreskjema-vis [skjema]="skjemakontroll().value.skjema.skjema"/>-->
            </div>
          }
        </fieldset>
      </div>
    </mat-step>

    <mat-step [stepControl]="skjemakontroll().controls.respondenter" label="{{'Velg respondenter'|translate}}">
      <div class="steg-respondenter">
        <!--<velg-medlemmer [skjemakontroll]="skjemakontroll().controls.respondenter" [medlemmer]="tilgjengeligeMedlemmer()"/>-->
        <h2>{{ 'Hvem skal svare på spørreundersøkelsen?'|translate }}</h2>
        <velg-medlemmer-tabell [skjemakontroll]="skjemakontroll().controls.respondenter"/>
      </div>
    </mat-step>

    @if (skjemakontroll().value.eksisterendeUndersoekelse != null) {
      <mat-step [stepControl]="skjemakontroll().controls.invitasjon" label="{{'Lagre'|translate}}">
        <div class="steg-lagre">
          <h2>{{ 'Lagre endringer i spørreundersøkelsen'|translate }}</h2>
          <p>{{ '"{tittel}" basert på spørreskjemaet "{skjema}". Du har valgt {antallRespondenter} respondenter.'|translate:{tittel: skjemakontroll().value.skjema!.tittel, skjema: skjemakontroll().value.skjema!.skjema?.tittel, antallRespondenter: antallRespondenter()} }}</p>
          @if (antallNyeRespondenter() > 0 || antallSlettedeRespondenter() > 0) {
            <inline-melding type="info">
              {{ "Du har lagt til {antallNye} ny(e) og fjernet {antallSlettede} respondenter"|translate:{antallNye: antallNyeRespondenter(), antallSlettede: antallSlettedeRespondenter()} }}
            </inline-melding>
          }
          <fieldset>
            @if (skjemakontroll().value.eksisterendeUndersoekelse!.erAapenForRespons) {
              <spoerreundersoekelse-invitasjon-skjema [skjemakontroll]="skjemakontroll().controls.invitasjon" [antallRespondenter]="antallNyeRespondenter()"/>

            } @else {
              <mat-slide-toggle [formControl]="skjemakontroll().controls.aapneForBesvarelse" class="åpne-undersøkelse-bryter">
                <div>{{ "Start spørreundersøkelsen nå" | translate }}</div>
                <div class="sub">{{ "Du kan åpne spørreundersøkelsen senere via menyen på spørreundersøkelsen." | translate }}</div>
              </mat-slide-toggle>
              @if (skjemakontroll().value.aapneForBesvarelse) {
                <spoerreundersoekelse-invitasjon-skjema [skjemakontroll]="skjemakontroll().controls.invitasjon" [antallRespondenter]="antallRespondenter()"/>
              }
            }
          </fieldset>
          <tips>{{ 'Når første respondent har svart, kan undersøkelsen ikke lenger redigeres'|translate }}</tips>
        </div>
      </mat-step>
    } @else {
      <mat-step [stepControl]="skjemakontroll().controls.invitasjon" label="{{'Opprett'|translate}}">
        <div class="steg-opprett">
          <h2>{{ 'Opprett spørreundersøkelsen'|translate }}</h2>
          <p>{{ '"{tittel}" basert på spørreskjemaet "{skjema}". Du har valgt {antallRespondenter} respondenter.'|translate:{tittel: skjemakontroll().value.skjema!.tittel, skjema: skjemakontroll().value.skjema!.skjema?.tittel, antallRespondenter: antallRespondenter()} }}</p>
          <fieldset>
            <mat-slide-toggle [formControl]="skjemakontroll().controls.aapneForBesvarelse" class="åpne-undersøkelse-bryter">
              <div>{{ "Start spørreundersøkelsen nå" | translate }}</div>
              <div class="sub">{{ "Du kan åpne spørreundersøkelsen senere via menyen på spørreundersøkelsen." | translate }}</div>
            </mat-slide-toggle>
            @if (skjemakontroll().value.aapneForBesvarelse) {
              <spoerreundersoekelse-invitasjon-skjema [skjemakontroll]="skjemakontroll().controls.invitasjon" [antallRespondenter]="antallRespondenter()"/>
            }
          </fieldset>
          <tips>{{ 'Når første respondent har svart, kan undersøkelsen ikke lenger redigeres'|translate }}</tips>
        </div>
      </mat-step>
    }

  </mat-stepper>
</form>
